import { Component, inject, Input, OnInit, ChangeDetectorRef, OnDestroy } from '@angular/core';
import { NzMenuDirective, NzMenuItemComponent, NzMenuModeType, NzMenuModule } from 'ng-zorro-antd/menu';
import { ɵNzTransitionPatchDirective } from 'ng-zorro-antd/core/transition-patch';
import { Router, RouterLink } from '@angular/router';
import { PermissionService } from 'src/app/core/services/permission.service';
import { NzBadgeModule } from 'ng-zorro-antd/badge';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-menu',
    standalone: true,
    imports: [
        RouterLink,
        ɵNzTransitionPatchDirective,
        NzMenuDirective,
        NzMenuItemComponent,
        NzMenuModule,
        NzBadgeModule
    ],
    templateUrl: './menu.component.html',
    styleUrl: './menu.component.scss'
})
export class MenuComponent implements OnInit, OnDestroy {

    private readonly cdr = inject(ChangeDetectorRef);
    private permissionsSubscription?: Subscription;
    
    @Input() nzMode: NzMenuModeType = 'vertical';
    @Input() class: string = '';
    @Input() countPauses = 0;

    environment: any;
    currentRoute!: string;

    private readonly permissionService = inject(PermissionService);

    constructor(
        private router: Router
    ) { }

    ngOnInit(): void {
        this.currentRoute = this.router.url;
        this.router.events.subscribe(() => {
            this.currentRoute = this.router.url;
        });
        this.permissionsSubscription = this.permissionService.permissionsChanged$.subscribe(() => {
            console.log('🔄 Menú: permisos cambiados, refrescando vista');
            this.cdr.markForCheck(); // fuerza re-render
        });
    }
    ngOnDestroy(): void {
        this.permissionsSubscription?.unsubscribe(); // 👈 limpieza
    }

    showNavMenuOption(permissionMainKey: string, permissionSubkey: string): boolean {
        return this.permissionService.canRead(permissionMainKey, permissionSubkey);
    }

    navigateTo(route:string){
        if(!this.showNavMenuOption('pauseReasons', '')){
            this.router.navigate([route]);
        }
    }
}
